<template>
	<div class="page__foot">
		<div style="margin: 0 auto;">
			<span class="footer-item"><icon name="copyright" scale="1"></icon> 2017 - BARNA-TASA, S.A.</span>
			<span class="footer-item"><icon name="home" scale="1"></icon> Carrer de Còrsega, 168, 1º 1ª, 08036 - Barcelona</span>
			<span class="footer-item"><icon name="phone" scale="1"></icon> (+34) 93 410 05 32</span>
			<span class="footer-item"><icon name="envelope" scale="1"></icon> info@barnatasa.com</span>
		</div>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import router from '../router'
    import { localStorageMixin } from '../mixins'

    export default {
        name: 'footer-bar',

        head: {
            title: {
                inner: 'Barnatasa'
            }
        }

    }
</script>

<style>
	.footer-item{
		padding-right: 1rem;
		padding-left: 1rem;
		white-space: nowrap;
	}
</style>


// WEBPACK FOOTER //
// FooterBar.vue?ce01c0d0